export default {
  updateStoreBooks(state, payload) {

    state.store = payload.sort(function (book1,book2) {
      return book1.title.localeCompare(book2.title);
    });

    let pubSet = new Set();
    var i = 0;

    for( i= 0;i<payload.length;i++){
      if (!pubSet.has(payload[i].publisher)) {
        pubSet.add(payload[i].publisher);
      }
    }

    state.publishers = pubSet;
  },
  setPublisher(state,pub){
    state.publisher = pub;
  },
  setReadingBook(state,book){
    state.readingBook = book;
    state.sample = false;
  },
  setSampleBook(state,sample){
    state.sample = sample;
  },
  updateBookMappings(state,mappings){
    state.bookMappings = mappings;
    state.chapter = mappings.cover;
  },
  updateBookMoves(state,moves){
    state.bookMoves = moves;
  },
  setChapter(state,chapter){
    state.chapter = chapter;
  },
  setChapterContent(state,content){
    state.chapterContent = content;
  },
  updateToc(state,toc){
    state.toc = toc;

    let div = document.createElement("div");
    div.innerHTML = toc;


    var href = '';
    if (f > -1) {

      if (event.target.nodeName.toLowerCase() === 'a') {
        href = event.target.outerHTML;
        href = href.substring(href.indexOf('"') + 1, href.lastIndexOf('"') + 1);
      } else {
        let parent = event.target.parentElement;

        if (parent.nodeName.toLowerCase() === 'a') {
          href = parent.outerHTML;
          href = href.substring(href.indexOf('"') + 1, href.lastIndexOf('"') + 1);
        }
      }

    }

    let f = navigator.userAgent.search("Firefox");
    let hrefs = div.querySelectorAll("a");
    hrefs.forEach(node => {
      var href = '';

      if(f > -1){
        href = node.outerHTML;
        href = href.substring(href.indexOf('"') + 1, href.lastIndexOf('"') + 1);
      }
      else{
        href = node.href;
      }

      href = href.substring(href.indexOf("href"));
      href = href.substring(5, href.length - 1);
      let chapterNumber = parseInt(href);
      // console.log( chapterNumber +"->"+node.text);

      for (var i = 0; i < state.bookMappings.chapterMappings.length; i++) {

        if (chapterNumber === state.bookMappings.chapterMappings[i].chapter) {
          state.bookMappings.chapterMappings[i].title = node.text;
        }
      }

    });
  }
}
